var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.items)?_c('model-select',{attrs:{"placeholder":"Seleziona l'accessorio...","defaultOptions":_vm.items,"id":_vm.idSelected,"canSearch":false,"value":null,"canCreate":false,"showTitle":false,"formClass":_vm.classes},on:{"selected":_vm.onItemSelected}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }